import React from 'react';

interface InductorProps {
    x: number;
    y: number;
    rotation?: number;
    value?: number;
    width?: number;
}

export const Inductor: React.FC<InductorProps> = ({
    x,
    y,
    rotation = 0,
    width = 60
}) => {
    const halfWidth = width / 2;
    // 4 loops
    const loopRadius = 8;
    const loopWidth = loopRadius * 2;
    const totalLoopWidth = loopWidth * 4;
    const lead = (width - totalLoopWidth) / 2;

    // Generate bumps
    const bumps = Array(4).fill(0).map((_, i) => {
        const startX = -halfWidth + lead + i * loopWidth;
        // Arc command: A rx ry x-axis-rotation large-arc-flag sweep-flag x y
        return `A ${loopRadius} ${loopRadius} 0 0 1 ${startX + loopWidth} 0`;
    }).join(' ');

    const pathData = `
    M ${-halfWidth} 0 L ${-halfWidth + lead} 0
    ${bumps}
    L ${halfWidth} 0
  `;

    return (
        <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
            <path d={pathData} stroke="#1a1a1a" strokeWidth="2" fill="none" strokeLinejoin="round" />
        </g>
    );
};
